// src/components/three/LevelUpWatcher.tsx
// ユーザーのレベル上昇を監視し、上がった瞬間だけ LevelUpCelebration を表示する。
// 初回スナップショットでは発火しない（既存レベルの読み込みで誤爆させない）。
import React, { useEffect, useRef, useState } from 'react';
import { onSnapshot } from 'firebase/firestore';
import { useAuth } from '@/contexts/AuthProvider';
import { useFirestore } from '@/hooks/useFirestore';
import LevelUpCelebration from './LevelUpCelebration';

const LevelUpWatcher: React.FC = () => {
    const { user } = useAuth();
    const firestore = useFirestore();
    const prevLevel = useRef<number | null>(null);
    const [celebration, setCelebration] = useState<{ open: boolean; level: number }>({
        open: false,
        level: 1,
    });

    useEffect(() => {
        prevLevel.current = null; // ユーザー切替時はリセット
        if (!user) return;
        const ref = firestore.getUserDoc(user.uid);
        const unsub = onSnapshot(ref, (snap) => {
            if (!snap.exists()) return;
            const level = typeof snap.data().level === 'number' ? snap.data().level : 1;
            if (prevLevel.current === null) {
                // 初回は基準値を記録するだけ
                prevLevel.current = level;
                return;
            }
            if (level > prevLevel.current) {
                setCelebration({ open: true, level });
            }
            prevLevel.current = level;
        });
        return () => unsub();
    }, [user, firestore]);

    return (
        <LevelUpCelebration
            open={celebration.open}
            level={celebration.level}
            message="おめでとうございます！学習の積み重ねが実を結んでいます。"
            onClose={() => setCelebration((c) => ({ ...c, open: false }))}
        />
    );
};

export default LevelUpWatcher;
